const LOOKUP_STAKEHOLDERS = "lookupStakeholders";
const STAKEHOLDER_RESULTS = "stakeholderResults";
const THANK_YOU = "thankYou"

export default {
  LOOKUP_STAKEHOLDERS,
  STAKEHOLDER_RESULTS,
  THANK_YOU
};
